import { mapFilterConstant, mapConstants } from "../actionTypes";
import $ from "jquery";
import moment from "moment";
import { userService } from "../middlewares/userService";
import { helper } from "../../utils/helpers/helper";
import { alertActions } from "./alertActions";

export const mapActions = {
  loadMapData,
  loadMapTodaysData,
  clearMapFilters,
  getFilterMetaResults,
  getFilterResults,
  getNextFilterResults,
  setZoomLevel,
  openFilterSidebar,
  clearMapErrors,
  getAreas,
  showMyPolygonListAction,
  getMyGeofenceData,
};

//MY POLYGONS LIST TOGGLE
function showMyPolygonListAction(val) {
  // alert(val);
  return (dispatch) => {
    dispatch(request(val));
  };

  function request() {
    return { type: mapConstants.SHOW_POLYGON_REQUEST, val };
  }
}

// MAP FILTER META
function getFilterMetaResults() {
  return (dispatch) => {
    dispatch(request());
    userService
      .getMapFilterMetaResults()
      .then((resp) => {
        dispatch(success(resp));
      })
      .catch((error) => {
        const resp = error?.response?.data;
        if (resp?.data) {
          error = resp?.data?.message;
        } else {
          error = "Please contact our team for further data and insights";
        }
        dispatch(alertActions.secondary(error));
        dispatch(failure(error));
      });
  };

  function request() {
    return { type: mapFilterConstant.FILTER_META_REQUEST };
  }
  function success(resp) {
    return { type: mapFilterConstant.FILTER_META_SUCCESS, resp };
  }
  function failure(error) {
    return { type: mapFilterConstant.FILTER_META_FAILURE, error };
  }
}

// MAP FILTER RESULTS
function getFilterResults(data) {
  const requestData = {
    // statdate: data.startdate,
    // enddate: data.enddate,
    startdate: data?.startdate !== null ? getFormatedDate(data?.startdate) : "",
    enddate: data?.enddate !== null ? getFormatedDate(data?.enddate) : "",
    // impact: data?.impact?.value !== null ? data?.impact?.value : "",
    // target: data?.target?.value !== null ? data?.target?.value : "",
    impact: (data?.impact !== null) ? (data?.impact?.value !== null ? data?.impact?.value : ""): "",
    target: (data?.target !== null) ? (data?.target?.value !== null ? data?.target?.value : ""): "",
    attackers: (data?.attackers !== null) ? (data?.attackers?.value !== null ? data?.attackers?.value : ""): "",
    accuracy: (data?.accuracy !== null) ? (data?.accuracy?.value !== null ? data?.accuracy?.value : ""): "",
    district: (data?.district !== null) ? (data?.district?.value !== null ? data?.district?.value : ""): "",
    attack: (data?.attack !== null) ? (data?.attack?.value !== null ? data?.attack?.value : ""): "",
    // attackers: data?.attackers?.value !== null ? data?.attackers?.value : "",
    // accuracy: data?.accuracy?.value !== null ? data?.accuracy?.value : "",
    // district: data?.district?.value !== null ? data?.district?.value : "",
    area: (data?.area !== null) ? (data?.area?.value !== null ? data?.area?.value : ""): "",
    keyword: data?.keyword !== null ? data?.keyword : "",
  };
  const getData = new URLSearchParams(requestData).toString();
  return (dispatch) => {
    dispatch(request({ data }));
    userService
      .getMapFilterResults(getData)
      .then((response) => {
        const resp = response?.data?.data;
        const filterResults = resp?.filtered_data;
        const nextPage = filterResults.next;
        const filter = helper.parse_filter_records(filterResults?.results);
        const finalResp = {
          filteredRecords: filter,
          heatMapRecords: resp?.heatMapRecords,
          totalRecordCount: filterResults?.count,
          recordCount:
            filterResults?.count !== 0
              ? filterResults?.count >= 50
                ? 50
                : filterResults?.count
              : 0,
          nextPage: nextPage,
        };
        dispatch(success(finalResp));
      })
      .catch((error) => {
        const resp = error?.response?.data;
        if (resp?.data) {
          error = resp?.data?.message;
        } else {
          error = "Please contact our team for further data and insights";
        }
        dispatch(failure(error));
        dispatch(alertActions.secondary(error));
      });
  };

  function getFormatedDate(date) {
    var d = "";
    if (date) {
      d = moment(date).format("YYYY-MM-DD");
      // var d = new Date("2015-03-25");
      // var month = parseInt(d.getMonth())+1;
      // return d.getFullYear()+"-"+month+"-"+d.getDate();
    }
    return d;
  }
  function request(resp) {
    return { type: mapFilterConstant.FILTER_REQUEST, resp };
  }
  function success(response) {
    return { type: mapFilterConstant.FILTER_SUCCESS, response };
  }
  function failure(error) {
    return { type: mapFilterConstant.FILTER_FAILURE, error };
  }
}

// MAP FILTER RESULTS NEXT PAGE
function getNextFilterResults(url, previousRecordCount) {
  return (dispatch) => {
    dispatch(request());
    userService
      .getMapFilterResultsNextPage(url)
      .then((response) => {
        const resp = response?.data?.data;
        const filterResults = resp?.filtered_data;
        const nextPage = filterResults.next;
        const filter = helper.parse_filter_records(filterResults?.results);
        const finalResp = {
          filteredRecords: filter,
          heatMapRecords: resp?.heatMapRecords,
          recordCount: previousRecordCount + 50,
          totalRecordCount: filterResults?.count,
          nextPage: nextPage,
        };
        dispatch(success(finalResp));
      })
      .catch((error) => {
        const resp = error?.response?.data;
        // const errorStatus = error?.response?.status;
        if (resp?.data) {
          error = resp?.data?.message;
        }
        dispatch(failure(error));
        dispatch(alertActions.secondary(error));
        // dispatch(alertActions.error(error));
      });
  };

  function request(resp) {
    return { type: mapFilterConstant.NEXTPAGE_FILTER_REQUEST, resp };
  }
  function success(response) {
    return { type: mapFilterConstant.NEXTPAGE_FILTER_SUCCESS, response };
  }
  function failure(error) {
    return { type: mapFilterConstant.NEXTPAGE_FILTER_FAILURE, error };
  }
}

function loadMapData(param = null) {
  return (dispatch) => {
    dispatch(request());
    userService
      .loadMapData(param)
      .then((response) => {
        const resp = response?.data?.data; //next
        const filterResults = resp?.filtered_data;
        const nextPage = filterResults.next;
        const filter = helper.parse_filter_records(filterResults?.results);
        const finalResp = {
          filteredRecords: filter,
          heatMapRecords: resp?.heatMapRecords,
          totalRecordCount: filterResults?.count,
          recordCount: filterResults?.count !== 0 ? 50 : 0,
          nextPage: nextPage,
        };
        dispatch(success(finalResp));
      })
      .catch((error) => {
        const resp = error?.response?.data;
        // const errorStatus = error?.response?.status;
        if (resp?.data) {
          error = resp?.data?.message;
        }
        dispatch(alertActions.secondary(error));
        dispatch(failure(error));
      });
  };

  function request() {
    return { type: mapFilterConstant.LOAD_MAP_REQUEST };
  }
  function success(response) {
    return { type: mapFilterConstant.LOAD_MAP_SUCCESS, response };
  }
  function failure(error) {
    return { type: mapFilterConstant.LOAD_MAP_FAILURE, error };
  }
}

function loadMapTodaysData() {
  const requestData = {
    startdate: moment().format("YYYY-MM-DD"),
    enddate: moment().format("YYYY-MM-DD"),
  };
  const getData = new URLSearchParams(requestData).toString();
  return (dispatch) => {
    dispatch(request());
    userService
      .loadMapTodaysData(getData)
      .then((response) => {
        const resp = response?.data?.data; //next
        const filterResults = resp?.filtered_data;
        const nextPage = filterResults.next;
        const filter = helper.parse_filter_records(filterResults?.results);
        const finalResp = {
          filteredRecords: filter,
          heatMapRecords: resp?.heatMapRecords,
          totalRecordCount: filterResults?.count,
          recordCount: filterResults?.count !== 0 ? 50 : 0,
          nextPage: nextPage,
        };
        dispatch(success(finalResp));
      })
      .catch((error) => {
        const resp = error?.response?.data;
        // const errorStatus = error?.response?.status;
        if (resp?.data) {
          error = resp?.data?.message;
        }
        dispatch(alertActions.secondary(error));
        dispatch(failure(error));
      });
  };

  function request() {
    return { type: mapFilterConstant.TODAY_INCIDENT_REQUEST };
  }
  function success(response) {
    return { type: mapFilterConstant.TODAY_INCIDENT_SUCCESS, response };
  }
  function failure(error) {
    return { type: mapFilterConstant.TODAY_INCIDENT_FAILURE, error };
  }
}

function setZoomLevel(data) {
  return (dispatch) => {
    dispatch(success(data));
  };
  function success(response) {
    return { type: mapFilterConstant.SET_ZOOM_LEVEL, response };
  }
}

function openFilterSidebar(showFilters, sidebarOpen) {
  return (dispatch) => {
    if (showFilters === true && sidebarOpen !== null) {
      let toogleSidebar = sidebarOpen === false ? true : false;
      dispatch(setSideBar(toogleSidebar));
    } else {
      if (sidebarOpen === null && showFilters === null) {
        let toogleSidebar = sidebarOpen === false ? true : false;
        dispatch(setSideBar(toogleSidebar));
        dispatch(setFilter(false));
      } else if (sidebarOpen === false && showFilters === false) {
        let toogleSidebar = sidebarOpen === false ? true : false;
        dispatch(setSideBar(toogleSidebar));
        dispatch(setFilter(false));
      } else if (sidebarOpen === true && showFilters === null) {
        let toogleSidebar = sidebarOpen === false ? true : false;
        dispatch(setSideBar(toogleSidebar));
        dispatch(setFilter(true));
      } else {
        $(".incidents").hide();
        dispatch(clear());
        dispatch(setFilter(showFilters));
      }
    }
  };
  function clear() {
    return { type: mapFilterConstant.RESOLVE_ERROR };
  }
  function setFilter(response) {
    return { type: mapFilterConstant.SET_FILTER, response };
  }
  function setSideBar(response) {
    return { type: mapFilterConstant.SET_SIDEBAR, response };
  }
}

function clearMapErrors() {
  $(".incidents").hide();
  return (dispatch) => {
    dispatch(success());
  };
  function success() {
    return { type: mapFilterConstant.RESOLVE_ERROR };
  }
}

function clearMapFilters(state) {
  return (dispatch) => {
    dispatch(clearFilter(state));
  };
  function clearFilter(state) {
    return { type: mapFilterConstant.CLEAR_FILTER_STATES, state };
  }
}

function getAreas(data) {
  const requestData = {
    district: data !== null ? helper.ucfirst(data) : "",
  };
  const getData = new URLSearchParams(requestData).toString();
  return (dispatch) => {
    dispatch(request({ data }));
    userService
      .getAreas(getData)
      .then((resp) => {
        dispatch(success(resp));
      })
      .catch((error) => {
        const resp = error?.response?.data;
        if (resp?.data) {
          error = resp?.data?.message;
        } else {
          error = "Please contact our team for further data and insights";
        }
        dispatch(failure(error));
        dispatch(alertActions.secondary(error));
      });
  };

  function request(resp) {
    return { type: mapFilterConstant.LOAD_AREAS_REQUEST, resp };
  }
  function success(resp) {
    return { type: mapFilterConstant.LOAD_AREAS_SUCCESS, resp };
  }
  function failure(error) {
    return { type: mapFilterConstant.LOAD_AREAS_FAILURE, error };
  }
}

// GET MY GEOFENCE DATA
function getMyGeofenceData() {
  return (dispatch) => {
    dispatch(request());
    userService
      .recieve_polygon()
      .then((resp) => {
        dispatch(success(resp));
      })
      .catch((error) => {
        const resp = error?.response?.data;
        if (resp?.data) {
          error = resp?.data?.message;
        } else {
          error =
            "Unable to load Geofences data. Please contact the network administrator";
        }
        dispatch(alertActions.secondary(error));
        dispatch(failure(error));
      });
  };

  function request() {
    return { type: mapFilterConstant.MY_GEOFENCE_DATA_REQ };
  }
  function success(resp) {
    return { type: mapFilterConstant.MY_GEOFENCE_DATA_SUCCESS, resp };
  }
  function failure(error) {
    return { type: mapFilterConstant.MY_GEOFENCE_DATA_FAILURE, error };
  }
}
